<template>
     <el-dropdown v-for="(item,index) in menuList" :key="index" trigger="hover">
    <span class="el-dropdown-link" :style="{color:titleColor}" @click="toPage(item.id)" >
      {{ item.title }}
    <div class="under_line" :class="curPage===index?'line':''"></div>
    </span>
    <template #dropdown>
      <el-dropdown-menu :style="item.children.length===0?{display:'none'}:''">
        <el-dropdown-item  v-for="(item2,index2) in item.children" :key="index2" @click="handleClick(item2)">{{ item2.name }}</el-dropdown-item>
      </el-dropdown-menu>
    </template>
  </el-dropdown>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue'

const { t } = useI18n()
const route = useRoute()

const curPage = ref(-1)
const menuList = computed(() => [
  {
    title: t('nav.about'),
    id: 11,
    children: [
      {
        name: t('nav.enterprise'),
        id: '1',
        path: '/about',
      },
      {
        name: t('nav.starTeam'),
        id: '2',
        path: '/about',
      },
      {
        name: t('nav.development'),
        id: '3',
        path: '/about',
      },
      {
        name: t('nav.honor'),
        id: '4',
        path: '/about',
      },
      {
        name: t('nav.contactInfo'),
        id: '5',
        path: '/about',
      },
    ],
  },
  {
    title: t('nav.product'),
    id: 22,
    children: [
      {
        name: t('nav.ruichangtai'),
        id: '6',
        path: '/product',
      },
      {
        name: t('nav.equipment'),
        id: '7',
        path: '/product',
      },
      {
        name: t('nav.research'),
        id: '8',
        path: '/product',
      },
      {
        name: t('nav.reagent'),
        id: '9',
        path: '/product',
      },
    ],
  },
  {
    title: t('nav.health'),
    id: 33,
    children: [],
  },
  {
    title: t('nav.contact'),
    id: 44,
    children: [
      {
        name: t('nav.contactInfo'),
        id: '13',
        path: '/contact',
      },
      {
        name: t('nav.recruit'),
        id: '14',
        path: '/contact',
      },
    ],
  },
  {
    title: t('nav.newsCenter'),
    id: 55,
    children: [],
  },
])

defineProps({
  isShow: {
    type: Boolean,
    default: true,
  },
  titleColor: {
    type: String,
    default: '',
  },
})

const emit = defineEmits(['menuClick', 'titleClick'])

const handleClick = (item: { id: string; path: string; name: string }) => {
  emit('menuClick', item)
}
const toPage = (id: number) => {
  emit('titleClick', id)
}

watch(
  () => route.fullPath,
  (fullPath) => {
    if (fullPath.includes('about')) {
      curPage.value = 0
    } else if (fullPath.includes('product') || fullPath.includes('proDetail')) {
      curPage.value = 1
    } else if (fullPath.includes('health')) {
      curPage.value = 2
    } else if (fullPath.includes('contact')) {
      curPage.value = 3
    } else if (fullPath.includes('newsCenter') || fullPath.includes('detail')) {
      curPage.value = 4
    } else {
      curPage.value = -1
    }
  },
  { immediate: true }
)
</script>

<style lang="less" scoped>
:deep(.el-popper){
  inset: 100px auto auto 410px !important;
}
    :deep(.el-tooltip__trigger:focus-visible) {
      outline: unset;
    }
    .el-dropdown{
      width: 120px;
      display: inline-flex;
      justify-content: center;
    }
    .el-dropdown-link{
        cursor: pointer;
        font-size: 16px;
        font-weight: 400;
        letter-spacing: 0.5px;
        white-space: nowrap;
        transition: color 0.3s ease;
        // color: #fff;
    }
    .el-dropdown-link:hover{
            color: #00A0E9 !important;
        }
    :deep(.el-dropdown-menu__item){
      transition: color 0.3s ease, border-color 0.3s ease;
    }
    :deep(.el-dropdown-menu__item):hover{
      color: #00A0E9;
      border-bottom: 2px solid #00A0E9;
    }
     .under_line{
      width: 0%;
      height: 2px;
      margin-top: 5px;
      border-radius: 1px;
      background: linear-gradient(to right, #00A0E9,#FFF100);
      transition: width 0.3s ease;
     }
     .el-dropdown-link:hover{
       .under_line{
         width: 100%;
       }
     }
     .line{
      width: 100%;
     }
    /* 中小分辨率屏幕下收紧间距，避免英文菜单换行或溢出 */
    @media (max-width: 1280px) {
      .el-dropdown{
        width: 104px;
      }
      .el-dropdown-link{
        font-size: 15px;
      }
    }
</style>
<style>
.el-dropdown__popper.el-popper:nth-child(3), .el-dropdown__popper.el-popper:nth-child(5){
  display: none !important;
}
</style>
